<script>
export default {
    name: 'IconArrowheadRight',
}
</script>
<template>
    <svg viewBox="0 0 64 64" class="base-icon icon-arrowhead-right" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4 0L50 31.8667L49.8714 31.9987L50 32.132L19.4 64L14 58.376L39.3273 32L14 5.624L19.4 0Z" fill="currentColor" />
    </svg>
</template>
